import { Link } from 'react-router-dom'
import { countryName, useCountriesQuery } from '@/features/settings/countriesApi'
import { useMessages, useUiLang } from '@/i18n'
import { messages } from './messages'

interface Props {
  /** ISO-код страны профиля; не выбрана или профиль не прочитан — `null`. */
  country: string | null
  /** Переход в настройки уводит со страницы — окно пополнения закрывается. */
  onNavigate: () => void
}

/**
 * Регион над витриной (PRD #71, п.28). От страны зависят валюта и способы
 * оплаты, а выбирается она в настройках аккаунта — строка называет её и
 * ведёт туда. Отдельный компонент, а не кусок витрины: тест строки не
 * должен зависеть от сетевой части диалога.
 */
export const RegionLine = ({ country, onNavigate }: Props) => {
  const m = useMessages(messages)
  const lang = useUiLang()
  const { data: countries } = useCountriesQuery(undefined, { skip: !country })
  const current = countries?.find((c) => c.code === country)
  // Справочник ещё едет — пока код, а не пустое место
  const name = current ? countryName(current, lang) : country

  return (
    <p className="text-sm text-muted-foreground">
      {name ? `${m.region}: ${name}` : m.regionNotSelected} ·{' '}
      <Link
        to="/settings/account"
        onClick={onNavigate}
        className="text-foreground underline underline-offset-2 hover:no-underline"
      >
        {name ? m.regionChange : m.regionPick}
      </Link>
    </p>
  )
}
